<!--- COMPONENTE PCLineaProduccionNumeroTrabajadores  ---->
<!---
Descripción del componente:
---------------------------

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="div-componentePCLineaProduccionNumeroTrabajadores">
    <!-----  LINEA PRODUCCIÓN CON TRABAJADORES MANUALES ----->
    <div
      v-if="lineaProduccionSeleccionada != null
        && lineaProduccionSeleccionada.UsoNumTrabajadoresManual"
      class="display-flex flex-direction-column align-items-center"
    >
      <div
        class="div-indicadorNumeroTrabajadoresLineaProduccion"
      >
        <img
          alt="iconTrabajador"
          align="right"
          src="@/static/icons/ic_workers_yellow_indicator.svg"
          class="img-indicadorNumeroTrabajadoresLineaProduccion"
        >
        <span
          class="span-indicadorNumeroTrabajadores"
        >  {{ numeroTrabajadoresLineaActual }} </span>
      </div>

      <div
        v-show="habilitarEdicion"
        class="div-cambioNumeroTrabajadoresLinea display-flex flex-direction-column align-items-center"
      >
        <div class="div-tituloNuevoNumeroTrabajadores">
          <small class="span-texto-gris-14-500">Nuevo número de trabajadores linea: </small>
        </div>
        <f7-stepper
          large
          fill
          :value="nuevoNumeroTrabajadoresLinea"
          :min="0"
          @input="nuevoNumeroTrabajadoresLinea = $event.target.value"
        />
        <f7-row class="row-datosDeFechaHoraInicio padding-top-half">
          <f7-col width="50">
            <UCDatePicker
              id="1"
              :title="$t('production.common.startDate')"
              @onchange="CambiarFechaEntradaNuevoNumeroTrabajadores"
            />
          </f7-col>
          <f7-col width="50">
            <UCTimePicker
              id="time-picker-to"
              :title="$t('production.common.startTime')"
              template="P2"
              @onchange="CambiarHoraEntradaNuevoNumeroTrabajadores"
            />
          </f7-col>
        </f7-row>
      </div>
    </div>
    <!----------- ÚLTIMOS REGISTROS NÚMEROS TRABAJADORES LINEA --------------->
    <div
      class="div-ultimosRegistrosTrabajadores"
      :class="{ 'div-ultimosRegistrosTrabajadores-sinEdicion': !habilitarEdicion }"
    >
      <div>
        <div class="div-tituloUltimosReistrosTrabajadores">
          <div class="div-elementoSeparador-total" />
          <span class="span-texto-azulOscuro-18-500">{{ $t('UltimosRegistrosDeTrabajadoresLinea').toUpperCase() }}</span>
          <div class="div-elementoSeparador-total" />
        </div>
        <UCPreload :show="mostrarPrecargaRegistrosNumeroTrabajadores" />
        <f7-col width="100">
          <f7-row
            v-for="(registro) in lstLineaProduccionNumeroTrabajadores"
            :key="registro.Id"
            class="div-registro"
          >
            <f7-col
              width="5"
              class="col-indicadorEstado"
            >
              <span
                v-if="!EsIntervaloActivo(registro)"
                class="inidicador-azul-8"
              />
              <span
                v-if="EsIntervaloActivo(registro)"
                class="inidicador-verde-8"
              />
            </f7-col>
            <f7-col
              width="35"
              class="div-registro-columna"
            >
              <span
                class="span-texto-gris-16-500"
              > {{ `${$t('production.common.startTime')}: ${FormatearHoraYMinutos(registro.HoraInicio)}` }} </span>
            </f7-col>
            <f7-col
              width="35"
              class="div-registro-columna"
            >
              <span
                v-if="!EsFechaNula(registro.HoraFin)"
                class="span-texto-gris-16-500"
              >  {{ `${$t('production.common.endTime')}: ${FormatearHoraYMinutos(registro.HoraFin)}` }}
              </span>
            </f7-col>
            <f7-col
              class="div-registro-columna"
              width="20"
            >
              <div>
                <img
                  alt="iconTrabajador"
                  src="@/static/icons/ic_workers_yellow_indicator.svg"
                  class="img-indicadorNumeroTrabajadoresLineaProduccionPequeño"
                >
                <span
                  class="cantidadTrabajadores"
                >  {{ registro.NumeroTrabajadores }} </span>
              </div>
            </f7-col>
          </f7-row>
        </f7-col>
      </div>
    </div>
    <!-- Botones aceptar confirmar -->

    <div class="div-elementoSeparador-90 div-separador" />
    <div class="div-opcionesActions">
      <f7-row>
        <f7-col
          width="50"
          class="col-izquierdaActions"
        >
          <a
            class="link link-izquierdaActions-2"
            @click="Cancelar()"
          > {{ $t('common.cancel').toUpperCase() }}</a>
        </f7-col>
        <f7-col
          width="50"
          class="col-derechaActions"
        >
          <a
            class="link link-derechaActions-2"
            @click="Confirmar()"
          > {{ $t('common.confirm').toUpperCase() }}</a>
        </f7-col>
      </f7-row>
    </div>
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCLineaProduccionNumeroTrabajadores',
  components: {
    UCDatePicker,
    UCTimePicker,
    UCPreload,
  },
  props: {
    activo: {
      type: Boolean,
      default: false,
    },
    lineaProduccionSeleccionada: {
      type: Object,
      default: null,
    },
    habilitarEdicion: {
      type: Boolean,
      default: true,
    },
  },

  emits: [
    'Cancelar',
    'Confirmar',
  ],

  data() {
    return {
      lstTrabajadoresLineaProduccion: [], // Se utiliza solo cuando la linea esta configurada como NO UsoNumTrabajadoresManual.
      lstLineaProduccionNumeroTrabajadores: [], // Intervalos manuales. Cuando la linea esta configurada como UsoNumTrabajadoresManual.
      numeroTrabajadoresLineaActual: 0,
      nuevoNumeroTrabajadoresLinea: 0,
      fechaHoraNuevoNumeroTrabajadores: null, // Si el usuario cambia los valores de fecha y hora se aplicaran esos nuevos valores, por defecto tomara la fecha y hora actual.
      mostrarPrecargaRegistrosNumeroTrabajadores: false,
    };
  },

  watch: {
    activo(val) {
      if (val) {
        this.InicializarComponente();
      }
    },
  },

  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.lstLineaProduccionNumeroTrabajadores = [];
      if (this.lineaProduccionSeleccionada.UsoNumTrabajadoresManual) {
        this.ObtenerNumeroTrabajadoresLinea();
        this.ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores();
      } else {
        this.ObtenerDatosDeTrabajadoresQueIntervienenLineaPedidoActivas();
      }
    },

    FormatearHoraYMinutos(fechaHora) {
      Log(this, this.FormatearHoraYMinutos.name);
      return SoporteFechaYHora.ObtenerHorasYMinutosDeCadenaHora(SoporteFechaYHora.obtenerHHMMSS(fechaHora));
    },

    EsFechaNula(fecha) {
      return SoporteFechaYHora.EsFechaNula(fecha);
    },

    EsIntervaloActivo(objTrabajadorLineaProduccion) {
      const ahora = Date.now();
      const horaInicio = new Date(objTrabajadorLineaProduccion.HoraInicio);
      const horaFin = new Date(objTrabajadorLineaProduccion.HoraFin);
      if (horaInicio <= ahora && this.EsFechaNula(objTrabajadorLineaProduccion.HoraFin)) {
        return true;
      }
      if (horaInicio <= ahora && horaFin > ahora) {
        return true;
      }
      return false;
    },

    ObtenerNumeroTrabajadoresLinea() {
      const self = this;
      const momentoConsulta = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      this.Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(this.lineaProduccionSeleccionada.Id, momentoConsulta)
        .then((result) => {
          self.numeroTrabajadoresLineaActual = result.Mensaje;
          // self.nuevoNumeroTrabajadoresLinea = self.numeroTrabajadoresLineaActual;
        })
        .catch((result) => {
          HiNotification.Toast(result.Mensaje);
        });
    },

    ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores() {
      Log(this, this.ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores.name);
      const self = this;
      this.mostrarPrecargaRegistrosNumeroTrabajadores = true;
      const numeroRegistrosObtener = 4;
      this.Conexion_ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores(this.lineaProduccionSeleccionada.Id, numeroRegistrosObtener)
        .then((result) => {
          self.lstLineaProduccionNumeroTrabajadores = JSON.parse(result.Mensaje);
        })
        .catch((result) => {
          LogError(`ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores --> ERROR: ${result}`);
        }).finally(() => {
          self.mostrarPrecargaRegistrosNumeroTrabajadores = false;
        });
    },

    ObtenerDatosDeTrabajadoresQueIntervienenLineaPedidoActivas() {
      Log(this, this.ObtenerDatosDeTrabajadoresQueIntervienenLineaPedidoActivas.name);
      const self = this;
      const momentoConsulta = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      this.Conexion_ObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion(this.lineaProduccionSeleccionada.Id, momentoConsulta)
        .then((result) => {
          self.lstTrabajadoresLineaProduccion = JSON.parse(result.Mensaje);
          self.numeroTrabajadoresLineaActual = self.lstTrabajadoresLineaProduccion.length;
          // self.nuevoNumeroTrabajadoresLinea = self.numeroTrabajadoresLineaActual;
        })
        .catch((result) => {
          LogError(`ObtenerDatosDeTrabajadoresQueIntervienenLineaPedidoActivas --> ERROR: ${result}`);
        });
    },

    CambiarFechaEntradaNuevoNumeroTrabajadores(nuevoValor) {
      Log(this, `PCLineaProduccionNumeroTrabajadores->CambiarFechaEntradaNuevoNumeroTrabajadores: ${nuevoValor}`);

      if (this.fechaHoraNuevoNumeroTrabajadores == null) {
        this.fechaHoraNuevoNumeroTrabajadores = `${SoporteFechaYHora.obtenerDDMMAA(nuevoValor)} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      } else {
        this.fechaHoraNuevoNumeroTrabajadores = `${SoporteFechaYHora.obtenerDDMMAA(nuevoValor)} ${SoporteFechaYHora.obtenerHorasYMinutos(Date(this.fechaHoraNuevoNumeroTrabajadores))} `;
      }
    },

    CambiarHoraEntradaNuevoNumeroTrabajadores(nuevoValor) {
      Log(this, `${this.CambiarHoraEntradaNuevoNumeroTrabajadores.name}: ${nuevoValor}`);
      if (this.fechaHoraNuevoNumeroTrabajadores == null) {
        this.fechaHoraNuevoNumeroTrabajadores = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${nuevoValor}`;
      } else {
        this.fechaHoraNuevoNumeroTrabajadores = `${this.fechaHoraNuevoNumeroTrabajadores.split(' ')[0]} ${nuevoValor} `;
      }
    },

    Cancelar() {
      Log(this, this.Cancelar.name);
      this.$emit('Cancelar');
    },

    Confirmar() {
      Log(this, this.Confirmar.name);
      if (this.nuevoNumeroTrabajadoresLinea === this.numeroTrabajadoresLineaActual) {
        this.Cancelar();
        return;
      }
      let momento = `${SoporteFechaYHora.obtenerDDMMAA(Date())} ${SoporteFechaYHora.obtenerHHMMSS(Date())}`;
      if (this.fechaHoraNuevoNumeroTrabajadores != null) {
        momento = this.fechaHoraNuevoNumeroTrabajadores;
      }

      PreloaderGH(true, true, 'Actualizando número trabajadores...', '');
      this.Conexion_GuardarNumeroTrabajadoresLinea(this.lineaProduccionSeleccionada.Id, this.nuevoNumeroTrabajadoresLinea, momento).then((result) => {
        if (result.Valor) {
          PreloaderGH(false);
          this.$emit('Confirmar');
        } else {
          PreloaderGH(false);
          HiNotification.Toast('Error al cambiar el número de trabajadores ');
        }
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('common.checkYourConnection'));
          LogError(error);
        });
    },

    Conexion_ObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento) {
      Log(this, 'PCLineaProduccionNumeroTrabajadores->Conexion_ObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerDatosDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_GuardarNumeroTrabajadoresLinea(idLineaProduccion, nuevoNumeroTrabajadoresLinea, momento) {
      Log(this, 'PCLineaProduccionNumeroTrabajadores->Conexion_GuardarNumeroTrabajadoresLinea');
      return new Promise((resolve, reject) => {
        ConexionTA.callGuardarNumeroTrabajadoresLinea(idLineaProduccion, nuevoNumeroTrabajadoresLinea, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento) {
      Log(this, 'FrmProductionPlanningStatus->Conexion_ObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerNumeroDeTrabajadoresQueIntervienenEnLineaProduccion(idLineaProduccion, momento)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },

    Conexion_ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores(idLineaProduccion, numeroIntervalosConsulta) {
      Log(this, 'FrmProductionPlanningStatus->Conexion_ObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUltimosIntervalosLineaProduccionNumeroTrabajadores(idLineaProduccion, numeroIntervalosConsulta)
          .then((result) => {
            if (result.Valor) {
              resolve(result);
            } else {
              reject(result);
            }
          })
          .catch((error) => {
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            LogError(error);
            reject();
          });
      });
    },
  },
};
</script>

<style scoped>
.div-indicadorNumeroTrabajadoresLineaProduccion {
  position: relative;
  width: 50px;
  height: 50px;
  margin-top: 10px;
  margin-left: 50px;
}

.span-indicadorNumeroTrabajadores {
  position: absolute;
  color: #fff;
  font-size: 39px;
  font-weight: 600;
  line-height: 29px;
  left: 14px;
  top: 53px;
}

.img-indicadorNumeroTrabajadoresLineaProduccion {
  width: 90px;
}

.img-indicadorNumeroTrabajadoresLineaProduccionPequeño {
  width: 30px;
}

.div-cambioNumeroTrabajadoresLinea {
  margin-top: 41px;
  width: calc(100% - (var(--f7-typography-margin) * 3));
}

.div-separador {
  width: 94%;
  bottom: 45px;
  position: absolute;
}

.div-opcionesActions {
  width: 94%;
  bottom: 10px;
  position: absolute;
}

.div-tituloNuevoNumeroTrabajadores {
  padding-bottom: 13px;
}

.row-datosDeFechaHoraInicio {
  width: 100%;
}

.div-tituloUltimosReistrosTrabajadores {
  margin-top: 15px;
  margin-bottom: 10px;
  margin-right: 20px;
  background: var(--his-blueberry-mist);
}

.col-indicadorEstado {
  padding-top: 3px;
}

.div-registro {
  padding: 0;
}

.div-ultimosRegistrosTrabajadores {
  margin-left: 20px;
}

.div-ultimosRegistrosTrabajadores-sinEdicion {
  margin-top: 70px;
}

.cantidadTrabajadores {
  width: 100%;
  color: var(--his-steel-blue);
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.35px;
  line-height: 41px;
  text-align: right;
}

.disabled-component {
  opacity: 0.6;
  pointer-events: none;
  user-select: none;
}
</style>
